<!-- /*--############################################################################
                  # Date :2025-05-14                                            
                 # Author : 권맑음                     
################################################################################*/ -->
<template>
  <div class="flex-col po-layout" @click="closeOtherTab">
    <Loading style="z-index: 100" />

    <div class="w100 po-gradient"></div>

    <!-- ===============================
        Header
    =============================== -->
    <div v-if="showMenu" class="po-header flex-between">
      <div class="w-left h-left">
        <div
          class="h-logo h-logo-nav-home hidden md:block"
          role="button"
          tabindex="0"
          title="대시보드로 이동"
          @click="goToDashboard"
          @keydown.enter.prevent="goToDashboard"
          @keydown.space.prevent="goToDashboard"
        >
          <!-- <img src="@/assets/images/logo.jpg" class="w100"> -->
          <img
            :key="strLogoUrl"
            :src="strLogoUrl"
            @error="handleError2"
            class="w100"
            alt=""
          />
        </div>
      </div>

      <div class="pd20 pt0 pb0 flex-between w-right h-right">
        <!-- GNB -->
        <nav class="flex items-center h-gnb">
          <a
            v-for="item in mainCategoryList"
            :key="item.lngCode"
            @click="selectCategory(item.lngCode)"
            :class="{ active: selectCategoryId === item.lngCode }"
          >
            {{ item.strTitle }}
          </a>
        </nav>

        <!-- Header Buttons -->
        <div class="h-controller">
          <button type="button" class="btn-action close" @click="deleteAllTabs">
            <i class="ico ico-close"></i>
          </button>
          <button type="button" class="btn-action refresh" @click="reLoadToolbar">
            <i class="ico ico-refresh"></i>
          </button>
          <button type="button" class="btn-action menu" @click.stop="showMenus">
            <i class="ico ico-menu"></i>
          </button>
        </div>

        <button class="bd-white-40 br5 f15 fw700 fc-white trs btn-logout" @click="logout">
          <!-- <img src="/src/assets/images/logout.svg"> -->
          <img src="@/assets/images/logout.svg">
          <span>로그아웃</span>
        </button>
      </div>
    </div>

    <!-- ===============================
        GNB Dropdown
    =============================== -->
    <div class="gnb-dropdown" v-show="showmenus">
      <a
        v-for="item in mainCategoryList"
        :key="item.lngCode"
        @click="selectCategory(item.lngCode)"
        :class="{ active: selectCategoryId === item.lngCode }"
      >
        {{ item.strTitle }}
      </a>
    </div>

    <!-- ===============================
        Content
    =============================== -->
    <div class="po-content">
      <!-- ===============================
          Left Menu
      =============================== -->
      <aside
        v-show="isMenu && showMenu"
        class="w-left sidemenu"
      >
        <BasicMenu
          v-if="showMenu"
          class="w100 h100"
          @emittab="emittab"
          @activeTab="activeTab"
          :selectCategoryId="selectCategoryId"
          :tabs="tabs"
          :triggerNow="triggerNow"
        />
      </aside>

      <!-- ===============================
          Right Content
      =============================== -->
      <div class="pd20 pl0 pt0 w-right">
        <!-- Tabs -->
        <div class="flex-between po-tabs">
          <div class="flex po-tabs-inner" ref="scrollContainer">
            <div
              v-for="tab in tabs"
              :key="tab.lngProgramID"
              class="po-tab-item"
              :class="{ active: currentActiveTab.lngProgramID === tab.lngProgramID }"
              @click="setActiveTab(tab)"
            >
              <span class="title">{{ tab.strTitle }}</span>
              <button class="btn-close" @click.stop="removeTab(tab)"></button>
            </div>
          </div>

          <div class="tab-actions">
            <button class="btn-action prev" @click="moveleft">
              <i class="ico ico-prev"></i>
            </button>
            <button class="btn-action next" @click="moveright">
              <i class="ico ico-next"></i>
            </button>
            <button class="btn-action close" @click="deleteAllTabs">
              <i class="ico ico-close"></i>
            </button>
            <button class="btn-action refresh" @click="reLoadToolbar">
              <i class="ico ico-refresh"></i>
            </button>
            <div class="btn-menu-group">
              <button class="btn-action menu" @click.stop="showMenus">
                <i class="ico ico-menu"></i>
              </button>
              <div class="tab-menu-popup" :class="{ open: showmenus }">
                <ul class="tab-menu-list">
                  <li
                    v-for="tab in tabs"
                    :key="tab.lngProgramID"
                    @click="setActiveTab(tab); showmenus = false;"
                  >
                    {{ tab.strTitle }}
                  </li>
                </ul>
              </div>
            </div>
            <button class="btn-action expand" @click="hideMenu">
              <i class="ico ico-expand"></i>
            </button>
          </div>
        </div>

        <!-- Router View — flex-1 로 h-full 페이지·그리드 높이 확보 (확대 full-mode 포함) -->
        <div class="po-router-view min-h-0 min-w-0 flex-1 overflow-hidden">
          <router-view v-slot="{ Component, route }" class="h-full min-h-0">
            <keep-alive>
              <component
                :is="Component"
                :key="`${route.path}-${componentKey}`"
                class="h-full min-h-0"
              />
            </keep-alive>
          </router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import BasicMenu from "@/components/BasicMenu.vue";
import Loading from "@/components/loading.vue";
import router from "@/router";
/**
 *  경고창 호출 라이브러리
 *  */

import Swal from "sweetalert2";
import { v4 } from "uuid";
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
/**
 *  Vuex 상태관리 및 로그인세션 관련 라이브러리
 */

import { useStore } from "vuex";

/** 로고 로드 실패 시·세션 없음 시 사용 */
import defaultLogoSrc from "@/assets/images/pncoffice_logo.png";
import { rgInstanceRegistry } from "@/components/realgridInstanceRegistry";
import {
  handleLogoImgError,
  resolveSessionLogoUrl,
} from "@/utils/resolveSessionLogoUrl";

const scrollContainer = ref(null);
const moveright = () => {
  if (!scrollContainer.value) return;
  scrollContainer.value.scrollLeft += 200;
};
const moveMaxright = () => {
  if (!scrollContainer.value) return;
  scrollContainer.value.scrollLeft = scrollContainer.value.scrollWidth + 2000;
};
const moveleft = () => {
  if (!scrollContainer.value) return;
  scrollContainer.value.scrollLeft -= 200;
};
/**
 * 	화면 Load시 실행 스크립트
 */

const closeOtherTab = () => {
  showmenus.value = false;
};
const route = useRoute();
const store = useStore();
/** 홈 대시보드로 이동 시 Vuex·insertPageLog 등이 기대하는 최소 탭 형태 (strUrl 없으면 strUrl.split 오류) */
const ROUTE_HOME_TAB = Object.freeze({
  strUrl: "HOME::MainDashBoard_VUE.xml",
  lngProgramID: "",
  strTitle: "대시보드",
});
const userData = computed(() => store.state.userData);

const strLogoUrl = computed(() =>
  resolveSessionLogoUrl(userData.value, defaultLogoSrc)
);

/** getLoginSession: strTopFColor → 시작, strTopTColor → 종료 (없으면 component.css 기본값) */
const applySessionTopGradient = () => {
  const u = store.state.userData;
  const root = document.documentElement;
  if (!u || typeof u !== "object" || Array.isArray(u)) {
    root.style.removeProperty("--gradient-primary");
    return;
  }
  const from = String(u.strTopFColor ?? u.strBackColor ?? "").trim();
  const to = String(u.strTopTColor ?? "").trim();
  if (from && to) {
    root.style.setProperty(
      "--gradient-primary",
      `linear-gradient(90deg, ${from} 0%, ${to} 100%)`
    );
  } else {
    root.style.removeProperty("--gradient-primary");
  }
};

watch(() => store.state.userData, applySessionTopGradient, { deep: true });

onMounted(() => {
  applySessionTopGradient();
});

const handleError2 = (e) => handleLogoImgError(e, defaultLogoSrc);

const mobileShowMenu = ref(false);
const showMenu = ref(route.path != "/"); // Initialize based on current route
const componentKey = ref(null);
// Watch for route changes

watch(
  () => route.path,
  (newPath) => {
    showMenu.value = newPath != "/"; // Update based on new route
  }
);
store.dispatch("convertLoading", false);
const deleteAllTabs = () => {
  Swal.fire({
    title: "확인",
    text: "열린화면을 모두 닫으시겠습니까?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "확인",
    cancelButtonText: "취소",
  }).then((result) => {
    if (result.isConfirmed) {
      //store.dispatch("closeAllTabs");
      tabs.value = [];
      currentActiveTab.value = { ...ROUTE_HOME_TAB };
      store.dispatch("saveActiveTab", { ...ROUTE_HOME_TAB });
      componentKey.value = null;
      router.push("/homePage");
    } else {
    }
  });
};

const showmenus = ref(false);

const showMenus = () => {
  showmenus.value = !showmenus.value;
};
const selectCategoryId = ref(1);
const triggerNow = ref(false);

const selectCategory = (category) => {
  //store.dispatch("selectCategory", category);\
  selectCategoryId.value = category;
  isMenu.value = true;
  syncBodyFullMode(true);
  mobileShowMenu.value = true;
  triggerNow.value = !triggerNow.value;
};

const logout = () => {
  store.dispatch("logout");
  //localStorage.clear();
  sessionStorage.clear();
  window.location.href = "/";

  //comsole.log(store.state);
};

const isMenu = ref(true);
const mainCategoryList = computed(() => store.state.mainCategory);
const clickFirstCategory = () => {
  const buttons = document.querySelectorAll('button[name="categorys"]'); // 모든 버튼 선택
  if (buttons.length > 0) {
    buttons[0].click(); // 첫 번째 버튼 클릭
  }
};
watch(mainCategoryList, (newCategories) => {
  if (newCategories.length > 0) {
    clickFirstCategory(); // 카테고리 목록이 변경되면 첫 번째 카테고리 클릭
  }
});

/**
 * 우측 상단 확대 — 좌측 메뉴 접기/펼치기.
 * body.full-mode + isMenu 를 같이 맞춤 (layout.css: 메뉴 display:none, w-right 100%).
 * public/js/common.js 의 jQuery full-mode toggle 은 제거함 (이중 토글 방지).
 * reLoad() 는 그리드 데이터가 사라져서 호출하지 않음.
 *
 * keep-alive 로 숨겨진 그리드까지 resetSize 하면 컨테이너 0px → 이후 탭 이동 시
 * 헤더·그리드가 안 보임. 보이는 그리드만 리사이즈하고, 탭 복귀는 realgrid onActivated.
 */
const syncBodyFullMode = (menuVisible) => {
  if (typeof document === "undefined") return;
  document.body.classList.toggle("full-mode", !menuVisible);
};

const isGridContainerVisible = (el) => {
  if (!el || !el.isConnected) return false;
  const rect = el.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
};

const resetVisibleRealgridsSize = () => {
  try {
    for (const [id, inst] of rgInstanceRegistry.entries()) {
      const el = document.getElementById(id);
      if (!isGridContainerVisible(el)) continue;
      inst?.gridView?.resetSize?.();
    }
  } catch (_) {
    /* ignore */
  }
};

const scheduleVisibleGridsResize = () => {
  nextTick(() => {
    window.dispatchEvent(new Event("resize"));
    requestAnimationFrame(() => {
      resetVisibleRealgridsSize();
      // 신규 화면 그리드 비동기 생성 직후에도 한 번 더
      setTimeout(() => resetVisibleRealgridsSize(), 120);
    });
  });
};

const hideMenu = () => {
  isMenu.value = !isMenu.value;
  syncBodyFullMode(isMenu.value);
  scheduleVisibleGridsResize();
};

onMounted(() => {
  syncBodyFullMode(isMenu.value);
});

watch(
  () => [route.path, route.query?.index],
  () => {
    scheduleVisibleGridsResize();
  }
);

const tabs = ref([]);
const emittab = async (e) => {
  tabs.value = e;
  await nextTick();
  moveMaxright();
};

const activeTab = (e) => {
  //comsole.log(e);
  //store.state.activeTab2 = e;
  store.dispatch("saveActiveTab", e);
  currentActiveTab.value = e;
  if (e?.lngProgramID) {
    componentKey.value = e.lngProgramID;
  }
};

const removedtabId = ref();
const removeTab = (tab) => {
  //comsole.log(tab);
  //comsole.log(tabs.value);
  tabs.value = tabs.value.filter(
    (item) => item.lngProgramID != tab.lngProgramID
  );
  const currentTab = tabs.value;
  if (currentTab.length > 0) {
    // @click.stop 안해서 상위 이벤트 전파때문에 안됬었음.

    currentActiveTab.value = tabs.value[tabs.value.length - 1];
    store.dispatch("saveActiveTab", currentActiveTab.value);
    const insteadProgramID = tabs.value[tabs.value.length - 1].lngProgramID;
    const insteadstrUrl = tabs.value[tabs.value.length - 1].strUrl;
    componentKey.value = insteadProgramID;
    // isActive(insteadtab);
    router.push({
      path:
        "/" + insteadstrUrl.split("::")[0] + "/" + insteadstrUrl.split("::")[1],
      query: { index: insteadProgramID },
    });
  } else {
    currentActiveTab.value = { ...ROUTE_HOME_TAB };
    store.dispatch("saveActiveTab", { ...ROUTE_HOME_TAB });
    componentKey.value = null;
    router.push("/homePage");
  }
};

//ref 는 기존의 변수까지 전부 병렬적으로 바꾸는거 같고 computed는 직렬적으로 바꾸는 것 같음

const reLoad = () => {
  // window.location.reload(); // 페이지 새로 고침
  //comsole.log(currentActiveTab.value);
  //comsole.log(tabs.value);
  if (!currentActiveTab.value || tabs.value.length == 0) {
    return;
  }
  const prevId = currentActiveTab.value.lngProgramID;
  if (prevId === "" || prevId == null) {
    return;
  }

  const baseId = String(prevId).split("_")[0];
  // 탭 객체 참조가 어긋난 경우(기존화면 이동 등)에도 같은 프로그램 탭을 찾는다
  let a = tabs.value.find((item) => item.lngProgramID == prevId);
  if (!a) {
    a = tabs.value.find(
      (item) =>
        String(item.lngProgramID).split("_")[0] === baseId &&
        item.strUrl === currentActiveTab.value.strUrl
    );
  }
  if (!a) {
    return;
  }

  const c = `${baseId}_${v4()}`;
  a.lngProgramID = c;
  // currentActiveTab 이 tabs 항목과 다른 객체여도 ID를 맞춘다
  currentActiveTab.value = { ...a };
  store.dispatch("saveActiveTab", currentActiveTab.value);
  componentKey.value = c;
  // query.index 와 componentKey 불일치 시 keep-alive 키가 되돌아가 리프레시가 무효화되는 문제 방지
  router
    .replace({
      path:
        "/" + a.strUrl.split("::")[0] + "/" + a.strUrl.split("::")[1],
      query: { index: c },
    })
    .catch(() => {});
};

/** 상단 리프레시 아이콘 전용 — 홈(매출분석·KPI)만 추가 갱신. 메뉴 토글 등 기존 reLoad 경로는 유지 */
const reLoadToolbar = () => {
  if (
    !currentActiveTab.value ||
    tabs.value.length == 0 ||
    currentActiveTab.value.lngProgramID == ""
  ) {
    componentKey.value = v4();
    return;
  }
  reLoad();
};

const currentActiveTab = ref({ ...ROUTE_HOME_TAB });

/** 다른 탭이 열려 있어도 홈 대시보드(homePage2)로 이동 — KPI·매출분석 대시보드 동일 경로 */
const goToDashboard = () => {
  currentActiveTab.value = { ...ROUTE_HOME_TAB };
  store.dispatch("saveActiveTab", { ...ROUTE_HOME_TAB });
  componentKey.value = null;
  router.push({ name: "homePage" }).catch(() => {});
};

const setActiveTab = (tab) => {
  // showmenus.value = false ;
  //store.dispatch("changeActiveTab", tab);
  currentActiveTab.value = tab;
  store.dispatch("saveActiveTab", tab);
  componentKey.value = tab.lngProgramID;
  //isActive(tab);
  router.push({
    path: "/" + tab.strUrl.split("::")[0] + "/" + tab.strUrl.split("::")[1],
    query: { index: tab.lngProgramID },
  });
};

watch(
  () => route.query,
  (newQuery) => {
    if (newQuery.index) {
      componentKey.value = newQuery.index;
    }
  }
);

watch(
  () => store.state.currentTabs,
  (newTabs) => {
    store.dispatch("changeActiveTab", newTabs);
    const activeTab = store.state.activeTab;
    componentKey.value = activeTab;
  }
);
</script>

<style scoped>
.layout {
  display: flex;
  height: 100vh;
  overflow: hidden; /* 화면 밖으로 나가는 애니메이션 방지 */
}

.sidebar {
  width: 20%;
  position: relative;
  background: blue;
  opacity: 0.6;
}

.main-content {
  width: 80%;
  position: relative;
  background: white;
  padding: 20px;
  overflow: hidden; /* 화면 밖으로 나가는 애니메이션 방지 */
}
.header-style-0 {
  background-color: #545876 !important;
  color: white !important;
}
.header-style-1 {
  background-color: #545876 !important;
  color: white !important;
}
.header-style-2 {
  background-color: #545876 !important;
  color: white !important;
}
.header-style-3 {
  background-color: #545876 !important;
  color: white !important;
}
.h-logo-nav-home {
  cursor: pointer;
  transition: box-shadow 0.18s, opacity 0.18s;
}
.h-logo-nav-home:hover {
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.6), 0 4px 14px rgba(0, 0, 0, 0.18);
  opacity: 0.92;
}
.h-logo-nav-home:active {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.4);
  opacity: 0.85;
}
.h-logo-nav-home:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.85);
  outline-offset: 2px;
}
</style>
